import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";


@Options({
    template: false,
    el: ".js-article-transcript-block",
    ui: {
        seeMoreButtonWrap:     ".js-content-see-more-btn-wrap",
        seeMoreButton:         ".js-btn-content-see-more",
        contentWrap:           ".js-content-wrap-expandable",
        transcriptWrap:        ".js-transcript-wrap"
    }
})

export default class ViewController extends Marionette.View<Backbone.Model>{
    constructor() {
        super();
    }

    // --------------------------------
    // EVENTS
    // --------------------------------

    @on("click @ui.seeMoreButton")
    onClickSeeMoreButton(JQueryEventObject: any) {
        this.findContentHeight();
    }

    // --------------------------------
    // FUNCTIONS
    // --------------------------------

    onRender() {
        console.log("transcript expander viewcontroller rendered");
    }

    findContentHeight() {
        const transcriptHeight = this.ui.transcriptWrap.outerHeight();
        const transitionSpeedMS = 300;

        this.ui.contentWrap
        .css({
            // Set height to prevent instant jumpdown when max height is removed
            "height": this.ui.contentWrap.height(),
            "max-height": 9999
        })
        .animate({
            "height": transcriptHeight
            }, transitionSpeedMS, "swing",
            // after animation complete, call...
            () => {
                this.ui.contentWrap.css("height", "auto");
            });

        this.ui.seeMoreButtonWrap.fadeOut(transitionSpeedMS, "swing");

        // prevent jump-down
        return false;
    }
}



// WEBPACK FOOTER //
// ./django/project/@static/@modules/transcript-expander/controller.ts